import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useCommonStyles } from "../../../style_util";
import { SimpleGrid, useSimpleGrid } from "../../../components/simple_grid";
import { useDrawer } from "../../../components/use_drawer";
import { bindInputValue, useInfo } from "../../../form_utils";
import { DeleteButton } from "../../../components/delete_button";
import { useContext } from "react";
import { Context } from "../../../context";
import { apiClient } from "../../../services/api";
import {
    DefDefectionDef,
    listDefDefection,
} from "../../../services/def_defection_service";

const DefDefectionForm = ({ item, onChange }) => {
    const { info, setInfo } = useInfo();
    const v = bindInputValue(item, info, setInfo);

    const onDelete = async () => {
        await apiClient.delete(`/defdefection/${item.id}`);
        onChange();
    };
    const onSave = async () => {
        if (item) {
            await apiClient.updateDefDefection(item.id, info);
            onChange();
        } else {
            info.seq = parseInt(info.seq);
            await apiClient.createDefDefection(info);
            onChange();
        }
    };

    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.form}>
            <FC.Input type="number" contentBefore={"编号"} {...v("seq")} />
            <FC.Input contentBefore={"名称"} {...v("name")} />
            <FC.Input contentBefore={"颜色"} {...v("color")} />
            <FC.Label>备注</FC.Label>
            <FC.Textarea {...v("description")} />

            <FC.Divider />
            {item && <DeleteButton onClick={onDelete} />}
            <FC.Button onClick={onSave} disabled={!info} appearance="primary">
                {(item && "保存") || "创建"}
            </FC.Button>
        </div>
    );
};

export const DefDefectionManagement = () => {
    const { openDrawer, closeDrawer, drawer } = useDrawer();

    const { items, refresh, SearchInput } = useSimpleGrid({
        listItems: listDefDefection,
        placeholder: "按名称搜索...",
    });

    const onFormChange = () => {
        refresh();
        closeDrawer();
    };
    const onNewDefDefection = () => {
        openDrawer({
            header: "创建缺陷类型",
            body: <DefDefectionForm item={null} onChange={onFormChange} />,
        });
    };
    const columns = [
        DefDefectionDef.createTableColumn("seq"),
        DefDefectionDef.createTableColumn("name"),
        DefDefectionDef.createTableColumn("color", {
            renderCell: (item) => {
                return (
                    <FC.TableCellLayout>
                        <div
                            style={{
                                backgroundColor: item.color || "black",
                                padding: "2px 8px",
                                borderRadius: 5,
                                fontSize: 11,
                                color: "white",
                            }}
                        >
                            {item.color}
                        </div>
                    </FC.TableCellLayout>
                );
            },
        }),
        DefDefectionDef.createTableColumn("description"),
        DefDefectionDef.createOpsColumn({
            renderCell: (item) => {
                const onClick = () => {
                    openDrawer({
                        header: "缺陷类型详情",
                        body: (
                            <DefDefectionForm
                                item={item}
                                onChange={onFormChange}
                            />
                        ),
                    });
                };
                return (
                    <FC.TableCellLayout>
                        <FC.Button
                            appearance="subtle"
                            icon={<IC.MoreCircleFilled />}
                            onClick={onClick}
                        />
                    </FC.TableCellLayout>
                );
            },
        }),
    ];
    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.root}>
            <div className={commonStyles.row}>
                <FC.Label>快速检索</FC.Label>
                <SearchInput />
                <FC.Button appearance="primary" onClick={onNewDefDefection}>
                    创建缺陷类型
                </FC.Button>
            </div>
            <SimpleGrid items={items} columns={columns} />
            {drawer}
        </div>
    );
};
